/** Modèles de séquence proposés à la création (le contenu est du Markdown : titres ## reconnus comme encadrés). */
export const LESSON_TEMPLATES = [
  {
    id: "complete",
    label: "Séquence complète",
    description: "Objectifs, situation professionnelle, notions, exemple, points à retenir et activité.",
    markdown: `## Objectifs
- À l'issue de cette séquence, vous saurez : ...
- Vous serez capable de : ...

## Situation professionnelle
Présentez ici un cas concret rencontré en entreprise.

## Les notions essentielles
Expliquez ici les notions, les définitions et les méthodes.

## Exemple concret
Illustrez avec un exemple réel, de préférence en Côte d'Ivoire.

## À retenir
- Point clé 1
- Point clé 2
- Point clé 3

## À vous de jouer
Proposez ici une activité ou un exercice à réaliser.
`,
  },
  {
    id: "cas",
    label: "Étude de cas",
    description: "Contexte, situation, données du problème et travail demandé.",
    markdown: `## Contexte
Présentez l'entreprise et son environnement.

## Situation professionnelle
Décrivez la situation à laquelle l'entreprise est confrontée.

## Données du problème
Listez les informations utiles (chiffres, contraintes, acteurs).

## Travail demandé
1. Première question
2. Deuxième question
3. Troisième question

## À retenir
- Enseignement principal du cas
`,
  },
  {
    id: "magistral",
    label: "Cours magistral",
    description: "Introduction, deux parties, exemple et synthèse.",
    markdown: `## Objectifs
- Objectif de la séquence

## Introduction
Présentez le sujet et sa problématique.

## Première partie
Développez la première idée.

## Deuxième partie
Développez la seconde idée.

## Exemple concret
Illustrez avec un exemple.

## À retenir
- Synthèse en quelques points
`,
  },
  {
    id: "courte",
    label: "Séquence courte",
    description: "Un texte simple suivi des points à retenir.",
    markdown: `Rédigez ici le contenu de la séquence.

## À retenir
- Point clé
`,
  },
];
